import { useState, useEffect, useRef } from 'react';
import { imageData } from './data';
import { ImageList, ImageListItem } from '@mui/material';
import {
    IntroWrapper,
    IntroCard,
    NameHeader,
    TraitText,
    BioText,
    ImagesWrapper,
    BottomBio
} from './styles/AboutMeStyles';

const traits = ['A Full-Stack Developer', 'AWS Developer Certified', 'Google Data Analytics Certified', 'A Creative Problem Solver', 'An Innovative Thinker', 'A Passionate Programmer'];

export default function AboutMe({ CardContainer, HeaderContainer }) {
    const [trait, setTrait] = useState(traits[0]);
    const [isFading, setIsFading] = useState(false);
    const indexRef = useRef(0);
    const fadeTimeoutRef = useRef(null);

    useEffect(() => {
        // initialize
        setTrait(traits[0]);

        const FADE_MS = 420;
        const INTERVAL_MS = 4800;

        const id = setInterval(() => {
            // start fade-out
            setIsFading(true);

            // after fade duration, update text and fade back in
            fadeTimeoutRef.current = setTimeout(() => {
                indexRef.current = (indexRef.current + 1) % traits.length;
                setTrait(traits[indexRef.current]);
                setIsFading(false);
            }, FADE_MS);
        }, INTERVAL_MS);

        return () => {
            clearInterval(id);
            if (fadeTimeoutRef.current) clearTimeout(fadeTimeoutRef.current);
        };
    }, []);

    return (
        <div className={CardContainer}>
            <div>
                <IntroWrapper>
                    <IntroCard>
                        <div>
                            <NameHeader>Hi, I'm Brandon</NameHeader>
                            <TraitText style={{ opacity: isFading ? 0 : 1 }}>{trait}</TraitText>
                        </div>
                        <BottomBio>
                            <BioText>
                                I'm a Full-Stack Web and Application Developer with a focus on building accessible,
                                maintainable, and performant experiences using React, NextJS, TypeScript, Java,
                                Node Package Manager/Maven, ExpressJS, Azure, AWS, Springboot, and many other languages and 
                                technologies. I started coding in 2021 and currently work as a Software Developer for Fusion Technology LLC.  
                                I have experience working with various cloud platforms, including AWS and Azure, and I am familiar with cloud 
                                architecture, deployment, and management.
                            </BioText>

                            <BioText>
                                I have a strong foundation in computer science principles and a passion for creating innovative 
                                solutions that solve real-world problems. I thrive in collaborative environments and enjoy 
                                working with teams to bring ideas to life. I enjoy collaborating with cross-functional teams 
                                to design pragmatic solutions that deliver real user value. Outside of work, I'm a musician, 
                                fitness enthusiast, and tabletop gamer. I'm always open to new challenges, so feel free to 
                                reach out to discuss opportunities or potential collaborations.
                            </BioText>
                        </BottomBio>
                    </IntroCard>

                    <ImagesWrapper>
                        <ImageList variant="masonry" cols={2} gap={8}>
                            {imageData.slice(0, 6).map((item) => (
                                <ImageListItem key={item.img}>
                                    <img
                                        src={`${item.img}?w=360&fit=crop&auto=format`}
                                        srcSet={`${item.img}?w=360&fit=crop&auto=format&dpr=2 2x`}
                                        alt={item.title}
                                        style={{ width: '100%', borderRadius: 8, display: 'block' }}
                                    />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </ImagesWrapper>
                </IntroWrapper>
            </div>
        </div>
    )
}
